import { render } from "./TitleLetters.vue?vue&type=template&id=36e9c0e0&scoped=true"
import script from "./TitleLetters.vue?vue&type=script&lang=js"
export * from "./TitleLetters.vue?vue&type=script&lang=js"

import "./TitleLetters.vue?vue&type=style&index=0&id=36e9c0e0&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-36e9c0e0"]])

export default __exports__